export default [
    {
        value: {
            value: 'Consumo',
            id: 501
        },
        label: '501',
    }, {
        value: {
            value: 'Devoluciones',
            id: 801
        },
        label: '801',
    }
];
